export const SuccessPageConstants = {
    HEADING: 'Success! Your demo account has been set up.',
    DEMO_ACCOUNT_MESSAGE: 'Remember, demo accounts will expire automatically and should not be used for a real class.',
    EMAIL_MESSAGE: 'Check your email. Your username and account information have been sent to the email you provided.',
    SEND_EMAIL_MESSAGE: 'Resend the email.',
    DEMO_ACCOUNT_BUTTON_LABEL: 'Start using my demo account'
};
